import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface BookingLocation {
  locationId: string;
  name: string;
}

export interface BookingSyncAssignment {
  locationId: string;
  title: string | null;
}

export interface BookingStaffProfile {
  displayName: string;
  email: string | null;
}

export interface BookingSyncStatus {
  factuProfile: { name: string; email: string | null };
  bookitProfile: BookingStaffProfile | null;
  locations: BookingLocation[];
  assignments: BookingSyncAssignment[];
}

export interface BookingSyncLocations {
  locations: BookingLocation[];
}

@Injectable({ providedIn: 'root' })
export class BookingStaffService {
  constructor(private http: HttpClient) {}

  getSyncStatus(employeeId: number): Observable<BookingSyncStatus> {
    return this.http.get<BookingSyncStatus>(
      `${environment.apiUrl}/api/v2/booking/staff/${employeeId}/sync-status`
    );
  }

  getSyncLocations(): Observable<BookingSyncLocations> {
    return this.http.get<BookingSyncLocations>(
      `${environment.apiUrl}/api/v2/booking/staff/sync-locations`
    );
  }

  sync(
    employeeId: number,
    data: {
      assignments: BookingSyncAssignment[];
      displayName?: string;
      email?: string;
      factuName?: string;
      factuEmail?: string;
    }
  ): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/api/v2/booking/staff/${employeeId}/sync`,
      data
    );
  }

  bulkSync(assignments: BookingSyncAssignment[]): Observable<{ synced: number }> {
    return this.http.post<{ synced: number }>(
      `${environment.apiUrl}/api/v2/booking/staff/bulk-sync`,
      { assignments }
    );
  }
}
